import gql from 'graphql-tag';
import { sessionFieldsFragment } from '@graphql/admin/fragments';

export const updateSessionMutation = gql`
  mutation UpdateSession($id: ID!, $input: UpdateSessionInput!) {
    updateSession(id: $id, input: $input) {
      ...AdminSessionFields
    }
  }

  ${sessionFieldsFragment}
`;